<template>
  <el-dialog class="el-dialogs" :append-to-body="true" title="批量新增节点" width="1000px"
             :close-on-click-modal="false"
             :visible.sync="visible">
    <el-row :gutter="10">
      <el-col :span="12">
        <div class="borderStyle">
          <div class="bodTitle">从语义库中选择</div>
          <div class="contentData matTop" v-loading="loading">
            <el-input
                size="mini"
                placeholder="输入关键字进行过滤"
                suffix-icon="el-icon-search"
                @input="searchTree"
                v-model="keyWorld">
            </el-input>
            <el-tree
                :data="treeData"
                show-checkbox ref="selectTree"
                node-key="id" :check-strictly="true"
                :default-expand-all="true"
                @check-change="handleCheckNode"
                :filter-node-method="filterNode"
                :props="defaultProps">
            </el-tree>
          </div>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="borderStyle">
          <div class="bodTitle">已选节点数据</div>
          <div class="contentData matTop">
            <el-tag
                v-for="item in selectNodes"
                :key="item.id"
                closable
                @close="deleteTag(item)">
              {{ item.dataName }}
            </el-tag>
          </div>
        </div>
      </el-col>
    </el-row>
    <div slot="footer">
      <el-button size="small" type="primary" @click="doSubmit()" v-noMoreClick>提交</el-button>
      <el-button size="small" @click="visible = false">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "batchAdd",
  data() {
    return {
      visible: false,
      loading: false,
      setlectListData: {},
      keyWorld: '',
      treeData: [],
      defaultProps: {
        children: 'children',
        label: 'semanticName'
      },
      selectNodes: [],
    }
  },
  methods: {
    init(setlectListData) {
      this.visible = true
      this.keyWorld = ''
      this.treeData = []
      this.selectNodes = []
      this.setlectListData = setlectListData
      this.getOthers()
    },

    getOthers() {
      this.loading = true
      this.$axios(this.api.academic.semanticcorpusQueryListAll, {}, 'get').then(data => {
        if (data && data.status) {
          this.loading = false
          this.treeData = data.data
          this.setNodeLevels(this.treeData)
        } else {
          this.$message.error(data.msg)
        }
      })
    },

    setNodeLevels(list) {
      if (!list) return
      list.forEach(node => {
        node.semanticName = node.semanticName + ' (' + node.semanticCorpusDataNum + ')'
        this.setNodeLevels(node.children)
      })
    },

    searchTree() {
      this.$refs.selectTree.filter(this.keyWorld);
    },

    filterNode(value, data) {
      if (!value) return true;
      return data.semanticName.indexOf(value) !== -1;
    },

    handleCheckNode() {
      let nodes = this.$refs.selectTree.getCheckedNodes()
      this.selectNodes = this.selectNodes.filter(item1 => {
        item1.parintId = item1.parintId.filter(item1 => {
          return nodes.findIndex(item2 => item2.id === item1) !== -1;
        });
        return item1.parintId.length != 0
      })
      let allSelectNode = []
      nodes.forEach(item => {
        item.semanticCorpusData.forEach(item2 => {
          this.$set(item2, 'parintId', item.id)
        })
        allSelectNode.push(...item.semanticCorpusData)
      })
      if (this.selectNodes.length == 0) {
        this.selectNodes = allSelectNode.map(item => {
          let data = JSON.parse(JSON.stringify(item))
          data.parintId = [data.parintId]
          return data
        })
      } else {
        let allParintIds = []
        let noRepeatData = []
        this.selectNodes.forEach(item => {
          allParintIds.push(...item.parintId)
        })
        allParintIds = [...new Set(allParintIds)];
        allSelectNode.forEach(item => {
          let reapet = allParintIds.filter(item2 => item.parintId == item2)
          if (reapet.length == 0) {
            noRepeatData.push(item)
          }
        })
        console.log(noRepeatData)
        noRepeatData.forEach(item => {
          let reapet = this.selectNodes.filter(item2 => item2.dataName == item.dataName)
          console.log('=========')
          console.log(reapet)
          if (reapet.length == 0) {
            let data = JSON.parse(JSON.stringify(item))
            data.parintId = [data.parintId]
            this.selectNodes.push(data)
          } else {
            this.selectNodes.forEach(item3 => {
              if (item3.dataName == reapet[0].dataName) {
                item3.parintId.push(item.parintId)
              }
            })
          }
        })
      }
    },

    deleteTag(row) {
      this.$confirm(`您是否确认删除数据?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.selectNodes = this.selectNodes.filter(item => item.id != row.id)
        let allParintIds = []
        this.selectNodes.forEach(item => {
          allParintIds.push(...item.parintId)
        })
        allParintIds = [...new Set(allParintIds)];
        this.$nextTick(() => {
          this.$refs.selectTree.setCheckedKeys(allParintIds)
        })
      })
    },

    doSubmit() {
      if (this.selectNodes.length == 0) {
        this.$message.warning('请至少选择一条数据')
        return
      }
      let nodeNames = this.selectNodes.map(item => item.dataName)
      this.$confirm(`确定后所选数据将被添加为知识模型的节点`, '确认添加所选数据？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios(this.api.academic.knowledgemodelnodeBatchSave, {
          modelId: this.setlectListData.id,
          nodeNames,
        }, 'post').then(data => {
          if (data && data.status) {
            this.$message.success(data.data)
            this.visible = false
            this.$emit('refresh')
          } else {
            this.$message.error(data.msg)
          }
        })
      })
    },
  }
  ,
}
</script>

<style scoped>
.borderStyle {
  border: 1px solid #EBEBEB;
  padding: 10px;
  border-radius: 10px;

  .bodTitle {
    font-size: 14px;
    font-weight: bold;
  }
}

.contentData {
  height: 380px;
  overflow-y: auto;
}

.matTop {
  margin-top: 10px;
}
</style>
